import { useEffect, useState } from 'react';
const isDocumentVisible = () => document.visibilityState !== 'hidden';
export const useVisiblePollInterval = pollInterval => {
  const [isVisible, setIsVisible] = useState(isDocumentVisible);
  useEffect(() => {
    const onVisibilityChange = () => setIsVisible(isDocumentVisible());
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);
  return isVisible ? pollInterval : undefined;
};